'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var yogokit = require('@wishket/yogokit');
require('../../../_virtual/_tslib.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

const BackDrop = ({ isBlack, preventScroll, onClick })=>{
    yogokit.usePreventScroll(preventScroll);
    return jsxRuntime.jsx(Box, {
        "data-testid": "design-system--backdrop",
        onClick: onClick,
        className: tailwindMerge.twMerge('fixed left-0 top-0 z-30 h-dvh w-dvw', isBlack ? 'bg-black bg-opacity-50' : 'bg-transparent')
    });
};

module.exports = BackDrop;
